// Empty-state hero + editable hero name (WEB-8003). Shared shell styles —
// composed by workspaceStyles.ts at the sections' original positions.
export const heroEmptyState = `
/* ===== Empty state / hero ===== */
.ws-empty {
  flex: 1;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  padding: 60px 32px 32px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}
.ws-empty-hero {
  width: 56px; height: 56px;
  border-radius: 14px;
  background: linear-gradient(145deg, #182b35, #1d3d48);
  color: #e8f9f8;
  display: grid; place-items: center;
  font-family: var(--ws-serif);
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
  overflow: hidden;
}
.ws-empty-hero img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ws-empty-hero:has(img) { background: transparent; }
.ws-empty-greeting {
  font-size: 13px;
  color: var(--ws-ink-4);
  margin-bottom: 6px;
}
.ws-empty h1 {
  font-family: var(--ws-sans);
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin: 0 0 8px;
  color: var(--ws-ink);
}
.ws-empty p {
  font-size: 14.5px;
  color: var(--ws-ink-3);
  max-width: 460px;
  text-align: center;
  line-height: 1.5;
  margin: 0 0 28px;
}
`;

export const heroEditableName = `
/* ===== Editable hero name ===== */
.ws-hero-name-editable {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: border-color 0.15s;
}
.ws-hero-name-editable:hover {
  border-bottom-color: var(--ws-ink-5);
}
.ws-hero-name-input {
  font-family: var(--ws-serif);
  font-size: 34px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: var(--ws-ink);
  background: transparent;
  border: none;
  border-bottom: 2px solid var(--ws-ink-3);
  outline: none;
  padding: 0;
  margin: 0;
  line-height: 1.05;
  width: 100%;
}
.ws-hero-title-editable {
  cursor: pointer;
  border-bottom: 1px solid transparent;
  transition: border-color 0.15s;
}
.ws-hero-title-editable:hover {
  border-bottom-color: var(--ws-ink-5);
}
.ws-hero-title-input {
  font-size: 13px;
  color: var(--ws-ink-4);
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--ws-ink-3);
  outline: none;
  padding: 0;
  margin: 0;
  font-family: var(--ws-sans);
  width: 200px;
}

@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* Animated ellipsis for inline loading text — content jumps at each keyframe
   (it can't interpolate), so it cycles . .. ... without a steps() timing fn. */
.ws-ellipsis::after { content: '.'; animation: ws-ellipsis 1.4s infinite; }
@keyframes ws-ellipsis {
  0%, 100% { content: '.'; }
  33% { content: '..'; }
  66% { content: '...'; }
}
`;
